import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetInsurerBillingClientAction } from "../../../redux/actions/PayoutAction";
import { TotalProveiderMonth } from "../PayOut/helper";

export const InsurerBillingClient = ({
  rowData,
  searchFilter,
  setRowData,
  setInsBillingPage,
  reCallApi,
  setReCallApi,
  payableData,
  setPayabelData,
  firstPageData,
  setSearchFilter,
  invoice,
  setInvoice
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  console.log("firstPageData",firstPageData)

  useEffect(() => {
    if (reCallApi === true) {
      dispatch(
        GetInsurerBillingClientAction({
          ...searchFilter,
          sessionId: rowData?.sessionID,
          ticketId: rowData?.requestID,
          providerId: null,
        })
      );
    }
     else {
      dispatch(
        GetInsurerBillingClientAction({
          ...searchFilter,
          sessionId: firstPageData?.sessionID,
          ticketId: firstPageData?.requestID,
          providerId: null,
        })
      );
    }
  }, []);

  return (
    <>
      <div className="table-responsive __custom__properties pt-2">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th style={{ minWidth:"250px" }}>Insurer Name</th>
              <th  style={{ textAlign: "center" }}>
                Month
              </th>
              <th style={{ textAlign: "center" }}>
                Insurer Amount
              </th>
              <th style={{ textAlign: "center" }}>
                GST
              </th>
              <th style={{ textAlign: "center" }}>
                Gross Amount
              </th>
              <th style={{ textAlign: "center" }}>
                Appointment
              </th>
              <th>Request Status</th>
              <th>Updated By</th>
              <th>Invoice</th>
            </tr>
          </thead>
          <tbody>
            {payoutReducer?.getFinanceQc?.map((ele, index) => {
              return (
                <tr key={ele?.clientId}>
                  <td>
                    <a
                      className="text-highlighted text-decoration"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setRowData(ele);
                        setInsBillingPage("secondPage");
                        setReCallApi(false);
                        setPayabelData([]);
                        setSearchFilter({
                          ...searchFilter,
                          providerName: "",
                          requestStatus: "",
                        });
                      }}
                    >
                      {ele?.clientName }
                    </a>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {TotalProveiderMonth(ele?.year, ele?.month)}
                  </td>
                  <td style={{ textAlign: "center" }}>{ele?.totalAmount?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>{ele?.gst?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>{ele?.netAmount?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>
                    {ele?.requestedAppointment}
                  </td>
                  <td>
                    <p
                      style={{ margin: "auto" }}
                      className={` status-style ${
                        ele?.requestStatus === "Paid"
                          ? "approved"
                          : ele?.requestStatus === "Reject By Finance" ||
                            ele?.requestStatus === "Not Paid "
                          ? "rejected"
                          : ele?.requestStatus === "Pending At Finance" ||
                            ele?.requestStatus === "Pending at Network"
                          ? "pendingAtFinance"
                          : ele?.requestStatus === "Pending For Payment"
                          ? "pendingForpayment"
                          : "pending"
                      }`}
                    >
                      {ele?.requestStatus}
                    </p>
                  </td>
                  <td>{ele?.updatedBy}</td>
                  <td>
                  <button
                    className="btn search__btn "
                    type="button"
                    disabled={ele?.requestStatus !== "Pending At QC" && ele?.requestStatus !== "Partial"}
                    onClick={() => {
                      setInvoice({ isOpen: true, rowData: ele });
                    }}
                    style={{ backgroundColor: "#5157A0" }}
                  >
                    Receivable Payable <i class="fa-solid fa-caret-right"></i>
                  </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
